/* global Alpine */
(function () {
  if (window.__flexibleAreaRegistered) {
    document.dispatchEvent(new CustomEvent('flexible-area-ready'));
    return;
  }

  var register = function () {
    if (window.__flexibleAreaRegistered) return;
    window.__flexibleAreaRegistered = true;

    Alpine.data('xFlexibleArea', function () {
      return {
        initArea: function (el) {
          var self = this;
          this.adjustFlexWidths(el);

          var resizeTimer;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              self.adjustFlexWidths(el);
            }, 50);
          });
        },

        adjustFlexWidths: function (container) {
          var isMobile = window.innerWidth <= 767;

          var items = Array.from(container.children).map(function (el) {
            var itemBlock = el.querySelector('.item-block');
            var itemWidth = parseFloat(isMobile ? itemBlock.dataset.widthMobile : itemBlock.dataset.width) || 1;
            return { el: el, itemWidth: itemWidth };
          });

          var style = getComputedStyle(container);
          var gap = parseFloat(style.columnGap || style.gap || 0);
          var containerWidth = container.getBoundingClientRect().width;

          var currentRow = [];
          var currentTotal = 0;
          var self = this;

          items.forEach(function (item) {
            if (currentRow.length && currentTotal + item.itemWidth > 100) {
              self.applyRowWidths(currentRow, gap, containerWidth);
              currentRow = [item];
              currentTotal = item.itemWidth;
            } else {
              currentRow.push(item);
              currentTotal += item.itemWidth;
            }
          });

          this.applyRowWidths(currentRow, gap, containerWidth);
        },

        applyRowWidths: function (row, gap, containerWidth) {
          if (!row.length) return;

          var totalGap = gap * (row.length - 1);
          var usableWidth = 100 - (totalGap / containerWidth) * 100;

          row.forEach(function (item) {
            item.el.style.flex = '0 0 ' + usableWidth * (item.itemWidth / 100) + '%';
          });
        }
      };
    });

    document.dispatchEvent(new CustomEvent('flexible-area-ready'));
  };

  if (window.Alpine) {
    register();
  } else {
    document.addEventListener('alpine:init', register);
  }

  if (window.Eurus && window.Eurus.loadedScript) {
    window.Eurus.loadedScript.add('flexible-area.js');
  }
})();
